import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgbModal, NgbActiveModal } from '@mattlewis92/ng-bootstrap';
import { GoogleData } from '../../services/GoogleData/GoogleData'


@Component({
    selector: 'google-viewer',
    templateUrl: './google-viewer.html',
    styleUrls: ['./google-viewer.css', './google-viewer.mobile.css'],
    encapsulation: ViewEncapsulation.None
})
export class GoogleViewerComponent implements OnInit {
    @Input() googleId:string;
    @Input() viewability:string;
    @Input() previewLinks:string;

    previewUrl:SafeUrl;
    

    isEmptyObject = function (item) {
        return !item || (!item.epub && !item.pdf);
    }
    constructor(private activeModal: NgbActiveModal, private sanitizer:DomSanitizer) { }

    ngOnInit() {
        if (GoogleData.validGoogleId.test(this.googleId)) {
            this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://books.google.com.au/books?id=' + this.googleId + '&printsec=frontcover&output=embed');
        } else {
            this.activeModal.close();
        }
    }
};



// WEBPACK FOOTER //
// ./web/static/components/google-viewer/google-viewer.ts